/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

Theme = {
  //=== TimeLine ===================================================
  Header: function() {    
    function getCurrentScroll() {
      return window.pageYOffset || document.documentElement.scrollTop;
    }
    
    $( window ).scroll(function() {      
      var scroll = getCurrentScroll();      
      if ( scroll >= 1 ) {
        $('.Header ').addClass('Header_Sticky');
      }
      else{
        $('.Header ').removeClass('Header_Sticky');
      }
      
    });
  }
}

$(function (){
  'use strict';
  Theme.Header();
});

/*
$( window ).resize(function () {    
  Theme.TimeLine();
});*/

$(document).ready(function(){

  $(".Product__SlideItem").click(function(){
  
    //$(".Product__SlideshowNavDot.is-selected").addClass("click");
    //$(".Product__SlideshowNavDot.is-selected").next("a").addClass("click").trigger("click");
  
  })

})